export enum ReturnURLKey {
  MyWorkspace = 1,
  TawajudiWorkspace = 2,
  DeparmentHeadWorkspace = 3,
  EmployeeWorkspace = 4,
  NationalAffairsWorkspace = 5,
  NotFoundItemsList = 6,
  TwajudiResidentsWorkspace = 9,
}
